import React, { useCallback } from 'react';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ImageDataType } from '../../../types/ImageDataType';

type AttachedImageProps = {
  className?: string;
  imageData?: ImageDataType;
  disabled?: boolean;
  onImageRemove: () => any;
  onImageLoaded: (imageWidth: number, imageHeight: number) => any;
};

export function AttachedImage({
  className,
  imageData,
  disabled,
  onImageRemove,
  onImageLoaded
}: AttachedImageProps) {
  const onImageLoadedCallback = useCallback<React.ReactEventHandler<HTMLImageElement>>(
    ev => {
      onImageLoaded(ev.currentTarget.naturalWidth, ev.currentTarget.naturalHeight);
    },
    [onImageLoaded]
  );

  return (
    <div className="relative">
      <img
        className={`w-full ${className}`}
        src={imageData.croppedImage || URL.createObjectURL(imageData.imageFile)}
        onLoad={onImageLoadedCallback}
      />
      <div
        className={
          'flex items-center justify-center rounded-full w-5 h-5 absolute top-0.5 right-0.5 cursor-pointer text-white ' +
          (disabled ? 'bg-navy-dark' : 'bg-red-light')
        }
        onClick={() => (disabled ? null : onImageRemove())}
      >
        <FontAwesomeIcon icon={faTimes} size="xs" />
      </div>
    </div>
  );
}
